import React from 'react';
import './AboutInfo.css'; // CSS for styling
import aboutbg from '../../img/about-bg.png'; // Correct image path

import about1 from '../../img/about-info.png'; // Correct image path
import about2 from '../../img/about-info2.svg'; // Correct image path
import about3 from '../../img/about-info3.png'; // Correct image path

const AboutInfo = () => {
  return (
    <div className="about-container">
      <div className="image-section">
        <div className="bg-background">
          <img src={aboutbg} alt="" />
        </div>
        <div className="image-wrapper image-blue">
          <div className="background blue-background"></div>
          <img src={about2} alt="Traveler 1" className="image-1" />
          <p className='overlay1'>All Listing</p>
        </div>
        <div className="image-wrapper image-green">
          <div className="background green-background"></div>
          <img src={about1} alt="Traveler 2" className="image-2" />
        </div>
        {/* <div className="image-wrapper image-graph">
          <div className="background graph-background"></div>
          <img src={about3} alt="Graph" className="image" />
        </div> */}
      </div>
      <div className="content-section-about">
        {/* <p className='about1'>About DreamTour</p> */}
        <h1>All-in-one platform for unforgettable travel experiences!</h1>
        <p>
        Wā.I.Saṅ, a venture based on the foundation of respect, acknowledgement and sensitivity
towards heritage, history, and culture. The name is an abbreviation of of the same - Wārsā
Itihās and Saṅskritī!
        </p>
        <ul>
          <li>
            <div className="icon red-icon">
              <i className="fas fa-user"></i> {/* Replace with appropriate icon */}
            </div>
            <div className="icon-info">

            The team encompasses experts from varied disciplines: Conservation, Architecture,
Archaeology, Indology, Art, Museology and Research, to name a few
</div>
          </li>
          <li>
            <div className="icon green-icon">
              <i className="fas fa-clipboard"></i> {/* Replace with appropriate icon */}
            </div>
            <div className="icon-info">
            Wā.I.Saṅ’s intention is
to encourage involvement, understanding and learning about the rich heritage around us
and take home a sensitive and aware moral through various Workshops, Lectures, Courses,
Heritage-walks, Heritage tours, etc. Apart from this we also collaborate with industry experts
wherever suitable
</div>
          </li>
        </ul>
        <h6 className="mission-section">Our Mission</h6>
        <h6 className='mission-info'>
        Heritage, History and culture are inseparable parts of all civilizations around the world.
Without culture, history cannot be represented and the stories of History are narrated by
heritage sites for ages. Some changes in culture are inevitable because the world is changing
at a fast pace. History is becoming convenient and heritage sites are disappearing.
Therefore, conservation of heritage sites, understanding of accurate history and preservation
of culture and a sensitive amalgamation of all these aspects is the need of the hour. Let's
combine ancient and modern to safeguard our heritage!
        </h6>
      </div>
    </div>
  );
};

export default AboutInfo;
